<template>
  <md-dialog
    :md-active="active"
    :class="['add-reservation-dialog', dialogVariant]"
    @update:mdActive="$emit('update:active', $event)"
  >
    <md-dialog-title>{{ title }}</md-dialog-title>
    <md-dialog-content class="add-reservation-content">
      <div class="md-layout add-reservation-form">
        <div class="md-layout-item md-size-100">
          <md-field class="option-select">
            <label>Departure</label>
            <md-input
              :value="departureSearch"
              :list="departureListId"
              :disabled="departuresLoading || !availableDepartures.length"
              @input="$emit('update:departureSearch', $event)"
              @change="$emit('apply-departure-search')"
              @blur="$emit('apply-departure-search')"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <div
            v-for="(row, index) in rows"
            :key="`add-row-${index}`"
            class="md-layout add-row"
          >
            <div class="md-layout-item md-size-16 md-small-size-100">
              <md-datepicker
                v-model="row.date"
                md-immediately
                :md-model-type="String"
              >
                <label>Date</label>
              </md-datepicker>
            </div>

            <slot name="row-fields" :row="row" :index="index"></slot>

            <div
              class="md-layout-item md-size-4 md-small-size-20 add-row-delete-cell"
            >
              <md-button
                class="md-just-icon md-simple md-danger"
                :disabled="rows.length === 1"
                @click="$emit('remove-row', index)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Remove Row</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>

        <div class="md-layout-item md-size-100">
          <md-button class="md-primary md-dense" @click="$emit('add-row')">
            <md-icon>add</md-icon>
            Add date row
          </md-button>
        </div>
      </div>

      <datalist :id="departureListId">
        <option
          v-for="departure in availableDepartures"
          :key="`dep-opt-${departure.id}`"
          :value="departure.label"
        ></option>
      </datalist>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('update:active', false)">
        Cancel
      </md-button>
      <md-button
        class="md-primary"
        :disabled="actionLoading || departuresLoading || !selectedDepartureId"
        @click="$emit('create-all-dates')"
      >
        <md-icon>add</md-icon>
        Create all dates
      </md-button>
      <md-button
        class="md-success"
        :disabled="
          actionLoading ||
            departuresLoading ||
            !selectedDepartureId ||
            !rows.some(row => row.date)
        "
        @click="$emit('add')"
      >
        Add
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: "AddReservationDialog",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Add Reservation"
    },
    dialogVariant: {
      type: String,
      default: "default"
    },
    departureSearch: {
      type: String,
      default: ""
    },
    selectedDepartureId: {
      type: [Number, String, null],
      default: null
    },
    departuresLoading: {
      type: Boolean,
      default: false
    },
    actionLoading: {
      type: Boolean,
      default: false
    },
    departureListId: {
      type: String,
      required: true
    },
    availableDepartures: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.add-row-delete-cell {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding-top: 14px;
}

.add-reservation-content {
  padding-top: 12px;
}

::v-deep .add-reservation-dialog .md-dialog {
  max-width: 760px;
  width: 90vw;
}

::v-deep .add-reservation-dialog.compact .md-dialog {
  max-width: 680px;
  width: 82vw;
}
</style>
